import React from 'react';
import ChatAppContain from '../../Componant/Chat/ChatApp';

const VoiceChat = () => {
  return (
    <div className='page-body'>
      <ChatAppContain />
    </div>
  );
};

export default VoiceChat;
